import SearchBar from "./SearchBar";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default SearchBar;
